import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function RevenueIndIntPercent({ chart_data }) {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    const labels = chart_data.map((item) => item.year);

    const indiaPercent = chart_data.map((item) => {
      const total = Number(item.india) + Number(item.international);
      return total ? ((item.india / total) * 100).toFixed(2) : 0;
    });

    const internationalPercent = chart_data.map((item) => {
      const total = Number(item.india) + Number(item.international);
      return total ? ((item.international / total) * 100).toFixed(2) : 0;
    });

    setData({
      labels,
      datasets: [
        {
          label: "India",
          data: indiaPercent,
          backgroundColor: "#36A2EB",
          borderRadius: 6,
          stack: "combined",
        },
        {
          label: "International",
          data: internationalPercent,
          backgroundColor: "#FF6384",
          borderRadius: 6,
          stack: "combined",
        },
      ],
    });

    setOptions({
      indexAxis: "y", // 🔥 horizontal
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          max: 100, // 🔥 force 100%
          ticks: {
            callback: (value) => value + "%",
          },
        },
        y: {
          stacked: true,
        },
      },
      plugins: {
        legend: {
          position: "top",
        },
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.dataset.label}: ${Number(context.raw).toFixed(2)}%`,
          },
        },
      },
    });
  }, [chart_data]);

  return (
    <div style={{ width: "100%", height: "320px" }}>
      {data?.datasets && <Bar data={data} options={options} />}
    </div>
  );
}

export default RevenueIndIntPercent;